import { disableBodyScroll, enableBodyScroll, queryAllFocusableElements, trapFocus } from '../../scripts/utils';

const menuSmallClass = 'c-menu-small';
const menuSmallOpenClass = menuSmallClass + '--open';

const menuSmallJsClass = 'js-menu-small';
const buttonCloseJsClass = menuSmallJsClass + '-button-close';

const accordionClass = 'c-accordion';
const accordionOpenClass = accordionClass + '--open';

const accordionJsClass = 'js-accordion';
const accordionButtonJsClass = accordionJsClass + '-button';

const headerJsClass = 'js-header';
const buttonOpenJsClass = headerJsClass + '-button-menu-small';

const menuSmallElement = document.querySelector('.' + menuSmallJsClass) as HTMLElement;
const buttonCloseElement = document.querySelector('.' + buttonCloseJsClass) as HTMLElement;

const buttonOpenElement = document.querySelector('.' + buttonOpenJsClass) as HTMLElement;

if (menuSmallElement && buttonCloseElement && buttonOpenElement) {
    const focusableElements = queryAllFocusableElements(menuSmallElement) as NodeListOf<HTMLElement>;
    const accordionElements = menuSmallElement.querySelectorAll('.' + accordionJsClass) as NodeListOf<HTMLElement>;

    if (focusableElements  && accordionElements) {
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        const lastAccordionElement = accordionElements[accordionElements.length - 1];

        // If the last focusable element is an accordion
        if (
            lastFocusableElement
            && lastAccordionElement
            && lastFocusableElement === lastAccordionElement
        ) {
            // Fix keyboard navigation on the last accordion
            const lastAccordionButtonElement = lastAccordionElement.querySelector('.' + accordionButtonJsClass) as HTMLElement;

            // Add keydown event listener to the close button
            buttonCloseElement.addEventListener('keydown', (event) => {
                // If the accordion is closed and the shift and tab keys are pressed
                if (
                    event.key === 'Tab'
                    && !event.ctrlKey
                    && !event.altKey
                    && !event.metaKey
                    && event.shiftKey
                    && !lastAccordionElement.classList.contains(accordionOpenClass)
                ) {
                    // Stop the default behavior
                    event.preventDefault();
                    // Focus the last accordion
                    lastAccordionButtonElement.focus();
                }
            });

            // Add keydown event listener to the last accordion
            lastAccordionButtonElement.addEventListener('keydown', (event) => {
                // If the accordion is closed and the tab key is pressed
                if (
                    event.key === 'Tab'
                    && !event.ctrlKey
                    && !event.altKey
                    && !event.metaKey
                    && !event.shiftKey
                    && !lastAccordionElement.classList.contains(accordionOpenClass)
                ) {
                    // Stop the default behavior
                    event.preventDefault();
                    // Focus the close button
                    buttonCloseElement.focus();
                }
            });
        }
    }

    // Add custom event listener to open the menu
    document.addEventListener('openMenuSmall', () => {
        openMenuSmall();
    });

    // Add click event listener on the button to close the menu
    buttonCloseElement.addEventListener('click', () => {
        closeMenuSmall();
    });

    // Add keydown event listener to close the menu
    menuSmallElement.addEventListener('keydown', (event) => {
        // If the menu is open and the escape key is pressed
        if (
            event.key === 'Escape'
            && !event.ctrlKey
            && !event.altKey
            && !event.metaKey
            && !event.shiftKey
            && menuSmallElement.classList.contains(menuSmallOpenClass)
        ) {
            // Close the menu
            closeMenuSmall();
        }
    });
}

function openMenuSmall () {
    if (!menuSmallElement || menuSmallElement.classList.contains(menuSmallOpenClass)) {
        return;
    }

    // Disable body scroll
    disableBodyScroll();

    // Add the active class on the menu
    menuSmallElement.classList.add(menuSmallOpenClass);

    // Update the menu's inert property to allow focus
    menuSmallElement.inert = false;

    updateMenuSmallFocus();
}

function closeMenuSmall () {
    if (!menuSmallElement || !buttonOpenElement || !menuSmallElement.classList.contains(menuSmallOpenClass)) {
        return;
    }

    // Enable body scroll
    enableBodyScroll();

    // Remove the active class on the menu
    menuSmallElement.classList.remove(menuSmallOpenClass);

    // Update the menu's inert property to prevent focus
    menuSmallElement.inert = true;

    // Set focus on the menu button
    buttonOpenElement.focus();
}

function updateMenuSmallFocus () {
    if (!menuSmallElement || !buttonCloseElement || !menuSmallElement.classList.contains(menuSmallOpenClass)) {
        return;
    }

    // Set focus on the close button
    buttonCloseElement.focus();

    // Trap focus inside the menu
    trapFocus(menuSmallElement);
}